import { allow } from '../classes/allow';
import is from '../objects/is';

export default function capitalizeFirstLetter(text = '') {
    allow.aString(text, is.not.empty);
    return text.charAt(0).toUpperCase() + text.slice(1);
}